import React from "react";
import { EditorTools } from "@progress/kendo-react-editor";
import { JSX } from "react/jsx-runtime";
import styled from "styled-components";

const { FontName } = EditorTools;

const StyledCustomFontName = styled.div`
  .custom-font-name-aligned {
    position: relative;
  }
  .custom-font-name-aligned .k-input-inner {
    color: transparent !important; /* Make text transparent instead of hiding */
    background: transparent !important;
    text-indent: -9999px !important; /* Push text out of view */
  }
  .custom-font-name-aligned .k-input-value-text {
    color: transparent !important; /* Make value text transparent */
    text-indent: -9999px !important; /* Push text out of view */
  }
  .custom-font-name-aligned .k-svg-icon {
    position: absolute !important;
    left: -21px !important; /* Position SVG closer to the left edge */
    top: 50% !important;
    transform: translateY(-50%) !important;
    z-index: 10 !important;
  }
  /* Force dropdown arrow to appear - Kendo style */
  .custom-font-name-aligned::after {
    content: "" !important;
    position: absolute !important;
    right: 10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 0 !important;
    height: 0 !important;
    border-left: 4px solid transparent !important;
    border-right: 4px solid transparent !important;
    border-top: 6px solid #000000 !important;
    pointer-events: none !important;
    z-index: 5 !important;
  }
`;

/**
 * Custom FontName component with 60px button width and custom font icon
 * Provides font name selection functionality for the WYSIWYG editor
 * Matches the width of ForeColor tool with a custom typography-style icon
 * Includes dropdown arrow for better UX
 */
const customFontNameIcon = {
  name: "font-name",
  content:
    '<path d="M256-240h84l44-122h192l44 122h84L522-720h-84L256-240Zm152-192 70-198h4l70 198H408ZM160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v640q0 33-23.5 56.5T800-80H160Zm0-80h640v-640H160v640Zm0-640v640-640Z"/>',
  viewBox: "0 -960 960 960"
};

export const CustomFontName = (
  props: JSX.IntrinsicAttributes & EditorTools.FontNameProps
) => (
  <StyledCustomFontName>
    <FontName
      {...props}
      // Additional props to override any Kendo defaults
      className={`${props.className || ""} custom-font-name-aligned`}
      // Custom popup settings for wider dropdown
      popupSettings={{
        ...props.popupSettings,
        width: "200px" // Wide enough for longer font names
      }}
      // 60px button width to match ForeColor tool
      style={{
        ...props.style,
        width: "60px", // Match ForeColor tool button width
        minWidth: "60px", // Prevent button from shrinking
        position: "relative" // Enable absolute positioning for icon
      }}
      // Custom SVG icon for the button
      svgIcon={customFontNameIcon}
    />
  </StyledCustomFontName>
);

export default CustomFontName;
